import list from 'src/modules/eventSchedule/list/eventScheduleListReducers';
import form from 'src/modules/eventSchedule/form/eventScheduleFormReducers';
import view from 'src/modules/eventSchedule/view/eventScheduleViewReducers';
import destroy from 'src/modules/eventSchedule/destroy/eventScheduleDestroyReducers';
import importerReducer from 'src/modules/eventSchedule/importer/eventScheduleImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
